import { render, staticRenderFns } from "./courseOrderManagement.vue?vue&type=template&id=da0ed8a0&"
import script from "./courseOrderManagement.vue?vue&type=script&lang=js&"
export * from "./courseOrderManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports